import { anchorFromUrl } from '@js/utils/completeTheSet';

/**
 * $completeTheSetAnchor(productId): the anchor product ID the page was opened with, or ''.
 * Used by the product form to carry a mini cart card link's anchor into Add to cart.
 */
export default {
  name: 'completeTheSetAnchor',
  magic: () => (productId) => anchorFromUrl(productId),
};
